<template>
    <div class="flex flex-col h-full items-center justify-center lg:px-0 lg:py-0 px-4 py-10">
        <h4 class="text-center m-y-md md:w-1/2 w-full">{{ $t('sign_up.add_organization_heading') }}</h4>
        <template v-if="invitation">
            <p class="md:w-2/3 text-center w-full" v-html="$t('sign_up.add_organization_with_invitation_info_long', {
                emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                name: `${invitation.sender.first_name} ${invitation.sender.last_name}`,
                emphasizedClose: '</span>'})">
            </p>
            <form-progress-bar :steps="2" :current-step="1"></form-progress-bar>
        </template>
        <template v-else>
            <p class="md:w-2/3 text-center w-full">{{ $t('sign_up.add_organization_info_long') }}</p>
            <form-progress-bar :steps="3" :current-step="2"></form-progress-bar>
        </template>

        <form class="md:w-1/2 w-full" @submit.prevent="onSubmit" @keydown="form.errors.forget($event.target.name)">
            <div class="mb-3" :class="{ 'has-error' : form.errors.has('name') }">
                <label class="mb-1" for="name">{{ $t('sign_up.organization_name') }}</label>
                <input class="form-control" id="name" name="name" type="text" :placeholder="$t('sign_up.organization_name_placeholder')" required autocomplete="off" v-model="form.name" />
                <p class="help-block" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></p>
            </div>
            <div class="mb-3" :class="{ 'has-error': form.errors.has('creator_persona') }">
                <label class="mb-1" for="creator_persona">{{ $t('sign_up.persona') }}</label>
                <div class="custom-controls-stacked m-t">
                    <label v-for="(creatorPersona, key) in creatorPersonas" class="custom-control custom-control-primary custom-radio">
                        <input @change="form.errors.forget($event.target.name)" class="custom-control-input" type="radio" name="creator_persona" :value="key" v-model="form.creator_persona">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">{{ creatorPersona }}</span>
                    </label>
                </div>
                <p class="help-block" v-if="form.errors.has('creator_persona')" v-text="form.errors.get('creator_persona')"></p>
            </div>
            <div class="flex items-center justify-between pt-2">
                <div>
                    <a v-if="invitation === null" @click="goBack()" class="font-medium link-muted no-underline text-left" href="javascript:;">&larr; {{ $t('globals.back') }}</a>
                </div>
                <button class="btn btn-primary" :disabled="form.errors.any()" type="submit">{{ $t('globals.continue') }}</button>
            </div>
        </form>

        <div class="md:w-2/3 pt-8 w-full">
            <div class="bg-gray-200 border-l-4 border-warning-500 p-4 rounded shadow" role="alert">
                <p class="mb-0">{{ $t('sign_up.add_organization_warning') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import FormProgressBar from './form-progress-bar.vue';

export default {
    components: {
        'form-progress-bar': FormProgressBar,
    },

    props: {
        organizationName: {
            type: String,
            default: null,
        },
        creatorPersona: {
            type: String,
            default: null,
        },
        creatorPersonas: {
            type: Object,
            required: true,
        },
        invitation: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            form: new Form({
                name: this.organizationName,
                creator_persona: this.creatorPersona,
            }),
        };
    },

    methods: {
        onSubmit() {
            Globals.post('/api/public/organizations/validate', this.form)
                .then(() => this.continue())
                .catch(() => {});
        },

        goBack() {
            Bus.$emit('changeScreen', { hash: '', step: 1 });
        },

        continue() {
            Bus.$emit('changeScreen', {
                hash: 'create',
                step: 3,
                organizationName: this.form.name,
                creatorPersona: this.form.creator_persona,
            });
        },
    },
};
</script>
